const decodeToken = params => {
  const token = params
    .get('token')
    .split('.')[1]
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  return JSON.parse(decodeURIComponent(escape(window.atob(token))));
};

export default decodeToken;
